(() => {
	const initFadeOnScroll = () => {
		if (typeof window === 'undefined') return;
		if (!('IntersectionObserver' in window)) return;

		if (
			document.body &&
			document.body.classList.contains('block-editor-page')
		) {
			return;
		}

		const containers = document.querySelectorAll(
			'.wp-block-sinthia-fade-on-scroll'
		);
		if (!containers.length) return;

		containers.forEach((container) => {
			const triggerOffset = Number(
				container.dataset.triggerOffset || 20
			);
			const stagger = Number(container.dataset.stagger || 0);
			const once = container.dataset.once !== 'false';
			const perItemTiming =
				container.dataset.perItemTiming === 'true';

			const items = Array.from(container.children).filter(
				(node) => node.nodeType === 1
			);
			if (!items.length) return;

			// 初期クラス付与とディレイ設定
			items.forEach((item, index) => {
				item.classList.add('sinthia-fade-item');

				// 「ディレイモード」のときだけ delay をセット
				if (!perItemTiming && stagger > 0) {
					const delayMs = stagger * index;
					item.style.setProperty(
						'--sinthia-fade-delay',
						`${delayMs}ms`
					);
				} else {
					// 念のため既存 delay を消しておく
					item.style.removeProperty('--sinthia-fade-delay');
				}
			});

			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						const target = entry.target;
						if (entry.isIntersecting) {
							target.classList.add('is-visible');
							if (once) {
								observer.unobserve(target);
							}
						} else if (!once) {
							target.classList.remove('is-visible');
						}
					});
				},
				{
					root: null,
					rootMargin: `0px 0px -${triggerOffset}% 0px`,
					threshold: 0,
				}
			);

			items.forEach((item) => observer.observe(item));
		});
	};

	if (typeof window === 'undefined') return;

	const onReady = () => {
		if ('requestIdleCallback' in window) {
			window.requestIdleCallback(initFadeOnScroll);
		} else {
			setTimeout(initFadeOnScroll, 0);
		}
	};

	if (
		document.readyState === 'complete' ||
		document.readyState === 'interactive'
	) {
		onReady();
	} else {
		document.addEventListener('DOMContentLoaded', onReady);
	}
})();
